import "./Payouts.css";
import { Helmet } from "react-helmet";
import Sidebar from "../components/Sidebar/Sidebar";
import Topbar from "../components/Topbar/Topbar";
import { useState } from "react";
import Search from "./components/Search/Search";
import RecentPayouts from "./components/RecentPayouts/RecentPayouts";
import SalesModal from "../components/Modals/RecentSales/RecentSales";
import Card from "./components/Card/Card";
import SidebarMobile from "../components/Sidebar/Mobile/SidebarMobile";

const Payouts = () => {
 const [recentPayoutsModal, setRecentPayoutsModal] = useState(false);

 return (
  <div className="payouts-dashboard">
   <Helmet>
    <title> Payouts | Dashboard | SHAP</title>
    <meta
     name="description"
     content="Knowledge-based digital products distribution at a premium"
    />
   </Helmet>
   <div className="wrapper">
    <div className="side-bar">
     <Sidebar active="payouts" />
    </div>
    <div className="side-bar-mobile">
     <SidebarMobile active="payouts" />
    </div>

    <div className="content-container">
     <div className="modal-wrapper">
      <div style={{ display: recentPayoutsModal ? "block" : "none" }}>
       <SalesModal setRecentSalesModal={setRecentPayoutsModal} />
      </div>
     </div>

     <Topbar heading="Payouts" />

     <div className="inner-content">
      <p style={{ color: "var(--primary-grey-text)" }}>
       Dashboard {"  >  "} Payouts
      </p>

      <div className="card-wrapper">
       <Card />
      </div>
      <div className="search-wrapper">
       <Search />
      </div>
      <div className="products-wrapper">
       <RecentPayouts setRecentPayoutsModal={setRecentPayoutsModal} />
      </div>
     </div>
    </div>
   </div>
  </div>
 );
};

export default Payouts;
